import ReceiptComponent from '@/components/Pages/Receipt.vue';
import RouteNames from '../constants/route-names';

const route = {
  path: '/company/:companyId/folder/:folderId/receipt/:paymentId',
  props: true,
  name: RouteNames.Receipt,
  component: ReceiptComponent,
};

export default route;
